((app) => {
    app.provider("dataSourceApi", [function() {
        this.$get = ["dataFeedApiGateway", (dataFeedApiGateway) => { 
            let service = {};

            // GETS
            service.getAllDataSourceEntities = () => {
                return dataFeedApiGateway.get("/SftpAPI/DataSourceEntities");
            }

            // POSTS
            service.createDataSourceEntity = (name, description) => {
                return dataFeedApiGateway.post("/SftpAPI/DataSourceEntities", { Name: name, Description: description });
            };

            return service;
        }]
    }]);
})(window.app);
